var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 39",
    d: "M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z",
    fill: "#03C074"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer 68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 117",
    d: "M21.1536 7.12469V10.4047C21.1536 10.6222 21.0672 10.8307 20.9134 10.9845C20.7596 11.1383 20.5511 11.2247 20.3336 11.2247C20.1161 11.2247 19.9075 11.1383 19.7538 10.9845C19.6 10.8307 19.5136 10.6222 19.5136 10.4047V9.19069L14.3896 15.0447C14.3131 15.1297 14.2201 15.1983 14.1163 15.2462C14.0125 15.2941 13.9 15.3204 13.7857 15.3235C13.6714 15.3266 13.5576 15.3064 13.4514 15.2641C13.3451 15.2219 13.2485 15.1584 13.1676 15.0777L11.3316 13.2247L6.16658 19.1437C6.09732 19.2303 6.01119 19.302 5.91341 19.3545C5.81563 19.4069 5.70823 19.4389 5.59772 19.4486C5.4872 19.4583 5.37587 19.4454 5.27046 19.4109C5.16505 19.3763 5.06775 19.3207 4.98445 19.2474C4.90116 19.1741 4.83359 19.0847 4.78586 18.9846C4.73812 18.8844 4.7112 18.7756 4.70672 18.6648C4.70225 18.5539 4.72031 18.4433 4.75982 18.3397C4.79933 18.236 4.85947 18.1414 4.93658 18.0617L10.6756 11.5047C10.7495 11.4196 10.8401 11.3507 10.9418 11.3022C11.0435 11.2537 11.1541 11.2267 11.2667 11.2229C11.3793 11.219 11.4914 11.2384 11.5962 11.2799C11.701 11.3213 11.7961 11.3839 11.8756 11.4637L13.7756 13.2997L18.4226 7.94469H17.0536C16.8361 7.94469 16.6275 7.8583 16.4738 7.70452C16.32 7.55074 16.2336 7.34217 16.2336 7.12469C16.2336 6.90721 16.32 6.69864 16.4738 6.54486C16.6275 6.39108 16.8361 6.30469 17.0536 6.30469H20.3326C20.4404 6.30456 20.5471 6.32567 20.6467 6.36682C20.7463 6.40797 20.8368 6.46835 20.9131 6.54451C20.9893 6.62066 21.0498 6.7111 21.0911 6.81066C21.1323 6.91021 21.1536 7.01692 21.1536 7.12469Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceUp);
export default __webpack_public_path__ + "static/media/priceUp.b43919bb3bf4441a48a55e326989b09c.svg";
export { ForwardRef as ReactComponent };